var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m26.508 12.273.035 10.51c0 .135-.01.27-.025.406v.807A2.003 2.003 0 0 1 24.515 26h-.802c-.055 0-.11 0-.165-.005-.07.005-.14.005-.21.005h-2.83a2.003 2.003 0 0 1-2.003-2.004v-4.41c0-.887-.717-1.603-1.603-1.603h-3.205a1.6 1.6 0 0 0-1.603 1.603v4.41A2.003 2.003 0 0 1 10.09 26h-2.8a3.39 3.39 0 0 1-.225-.01c-.06.005-.12.01-.18.01h-.802a2.003 2.003 0 0 1-2.003-2.004v-5.612c0-.045 0-.096.005-.14v-5.97l10.131-9.046c.351-.35.752-.4 1.102-.4.35 0 .752.1 1.052.35z",
    opacity: 0.242
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.328,
    d: "M2 13.172 15.298 2 28 13.172"
  }))));
};
export default SvgHouse;